// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global body styles to prevent white flash */
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #252525;
  min-height: 100vh;
}

#root {
  min-height: 100vh;
}

.App {
  text-align: center;
  min-height: 100vh;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Authentication Styles */
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #181a1b;
  background-size: cover;
}

.login-card {
  background-color: rgba(24, 26, 27, 0.9);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.7);
  padding: 2rem;
  width: 100%;
  max-width: 400px;
  color: white;
}

.login-card h2 {
  margin-bottom: 1.5rem;
  text-align: center;
  font-size: 2rem;
  color: #ffffff;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
  text-align: left;
}

.form-group input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #444;
  border-radius: 4px;
  background-color: #222;
  color: white;
  font-size: 1rem;
  box-sizing: border-box;
}

.form-group input:focus {
  outline: none;
  border-color: #4a9eff;
}

.login-button {
  width: 100%;
  padding: 0.75rem;
  background-color: #4a9eff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

.login-button:hover {
  background-color: #3a8aff;
}

.error-message {
  background-color: rgba(255, 0, 0, 0.1);
  border-left: 4px solid #ff3333;
  color: #ff3333;
  padding: 0.75rem;
  margin-bottom: 1.5rem;
  border-radius: 4px;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  color: white;
  background-color: #181a1b;
}

.spinner {
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  border-top: 4px solid #4a9eff;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Navbar Styles */
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #222;
  padding: 0.75rem 1.5rem;
  color: white;
  border-bottom: 1px solid #444;
}

.navbar-brand {
  font-size: 1.5rem;
  font-weight: bold;
  color: #4a9eff;
}

.navbar-user {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.username {
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.admin-badge {
  background-color: #4a9eff;
  color: white;
  font-size: 0.7rem;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  font-weight: bold;
  text-transform: uppercase;
}

.logout-button {
  background-color: transparent;
  border: 1px solid #666;
  color: white;
  padding: 0.4rem 0.75rem;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.logout-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: #999;
}

/* Smooth Loading Animations */
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeOutDown {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(30px);
  }
}

@keyframes fadeOutUp {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-30px);
  }
}

@keyframes slideInFromLeft {
  0% {
    opacity: 0;
    transform: translateX(-30px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideOutToRight {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(50px);
  }
}

/* Bucket fade-in animation with staggered delay */
.bucket-container {
  position: relative;
  transition: transform 0.5s ease, opacity 0.3s ease;
}

.bucket-container--fade-in {
  animation: slideInFromLeft 0.6s ease-out;
  animation-fill-mode: both;
}

.bucket-container--animating-out {
  animation: slideOutToRight 0.4s ease-out;
  animation-fill-mode: both;
}

.bucket-container:nth-child(1) { animation-delay: 0.1s; }
.bucket-container:nth-child(2) { animation-delay: 0.2s; }
.bucket-container:nth-child(3) { animation-delay: 0.3s; }
.bucket-container:nth-child(4) { animation-delay: 0.4s; }
.bucket-container:nth-child(5) { animation-delay: 0.5s; }

/* Ticket animations */
.ticket-item {
  animation: fadeInUp 0.4s ease-out;
  animation-fill-mode: both;
}

.ticket-item-exit {
  animation: fadeOutDown 0.3s ease-out;
  animation-fill-mode: both;
}

.ticket-item-done {
  animation: fadeOutUp 0.2s ease-out;
  animation-fill-mode: both;
}

/*
 * NOTE: Removed global * { transition } rule - it was breaking CSS animations
 * Transitions should be applied to specific elements that need them instead
 */

/* Bucket container with infinite scrolling background */
.bucket-container-scroll {
  position: relative; /* Required for absolute positioning of ::before overlay */
  /* Background scrolls with container content - attachment: local */
  background-color: #252525;
  background-size: 760px 760px;
  background-repeat: repeat;
  background-attachment: local; /* Scrolls WITH the container in all directions */
  /* Smooth transitions for layout changes */
  transition: all 0.3s ease;
  /* CSS variable for brightness control via opacity overlay */
  --bg-brightness: 100%;
}

/* Dark overlay for brightness control - only affects background, not navbar */
.bucket-container-scroll::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* Dark overlay - opacity controlled by brightness */
  /* brightness 100% = no overlay, brightness 50% = 50% dark overlay, brightness 200% = white overlay */
  background-color: rgba(0, 0, 0, calc((100 - var(--bg-brightness)) / 100));
  z-index: 0;
  pointer-events: none;
  transition: background-color 0.3s ease;
}

.bucket-container-scroll > * {
  position: relative;
  z-index: 1;
  transition: transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Custom scrollbar for bucket container */
.bucket-container-scroll::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.bucket-container-scroll::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.bucket-container-scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

.bucket-container-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Hide scrollbar for bucket navbar */
.bucket-navbar::-webkit-scrollbar {
  display: none;
}

.bucket-navbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* Mobile Media Queries */
@media (max-width: 768px) {
  /* Mobile bucket container with horizontal scrolling */
  .bucket-container-scroll {
    display: flex !important;
    flex-direction: row !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    scroll-snap-type: x proximity !important;
    -webkit-overflow-scrolling: touch !important;
    padding: 10px 0 !important;
    gap: 20px !important;
    min-height: calc(100vh - 120px) !important;
    align-items: flex-start !important;
    /* Enhanced scroll behavior */
    scroll-behavior: smooth !important;
    scrollbar-width: none !important;
    -ms-overflow-style: none !important;
  }

  /* Mobile bucket styling */
  .bucket-container {
    min-width: 320px !important;
    width: 320px !important;
    scroll-snap-align: center !important;
    flex-shrink: 0 !important;
    flex-grow: 1 !important;
    margin-right: 0 !important;
    display: block !important;
  }

  /* First bucket gets left padding to center properly */
  .bucket-container:first-child {
    margin-left: calc(50vw - 160px) !important;
  }

  /* Last bucket gets right padding to center properly */
  .bucket-container:last-child {
    margin-right: calc(50vw - 160px) !important;
  }

  /* Mobile bucket content */
  .bucket-container > div {
    width: 320px !important;
    min-width: 320px !important;
    height: auto !important;
    max-height: calc(100vh - 140px) !important;
    box-sizing: border-box !important;
    padding: 12px !important;
    margin: 0 !important;
    position: relative !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
  }

  /* Ensure bucket content has proper spacing */
  .bucket-container > div > div {
    width: 100% !important;
    box-sizing: border-box !important;
  }

  /* Mobile bucket navbar */
  .bucket-navbar {
    position: fixed !important;
    top: 60px !important;
    bottom: auto !important;
    left: 0 !important;
    right: 0 !important;
    height: 50px !important;
    background-color: rgba(24, 26, 27, 0.98) !important;
    backdrop-filter: blur(15px) !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2) !important;
    border-top: none !important;
    padding: 8px 15px !important;
    z-index: 90 !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3) !important;
  }

  /* Mobile bucket navbar buttons */
  .bucket-nav-button {
    min-width: 80px !important;
    height: 44px !important;
    padding: 8px 12px !important;
    font-size: 12px !important;
    border-radius: 8px !important;
    background-color: rgba(255, 255, 255, 0.12) !important;
    border: 1px solid rgba(255, 255, 255, 0.25) !important;
    touch-action: manipulation !important;
  }

  .bucket-nav-button:hover,
  .bucket-nav-button:active {
    background-color: rgba(255, 255, 255, 0.2) !important;
    border-color: rgba(255, 255, 255, 0.4) !important;
    transform: scale(1.05) !important;
  }

  .bucket-nav-button--highlight {
    background-color: rgba(0, 123, 255, 0.8) !important;
    border: 2px solid rgba(0, 123, 255, 1) !important;
    box-shadow: 0 0 15px rgba(0, 123, 255, 0.6) !important;
    transform: scale(1.1) !important;
  }

  /* Adjust main content for mobile navbar */
  .App {
    padding-bottom: 0 !important;
  }

  /* Mobile-specific scrollbar styling */
  .bucket-container-scroll::-webkit-scrollbar {
    display: none !important;
  }

  .bucket-container-scroll {
    -ms-overflow-style: none !important;
    scrollbar-width: none !important;
  }

  /* Mobile ticket styling */
  .ticket-item {
    margin-bottom: 7px !important; /* 7px margins matching all other spacing */
  }

  /* Mobile navbar at top */
  .navbar {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    z-index: 101 !important;
    height: 60px !important;
    padding: 0.5rem 1rem !important;
  }

  /* Adjust content for fixed navbar */
  .bucket-container-scroll {
    margin-top: 110px !important;
    min-height: calc(100vh - 110px) !important;
    padding-top: 10px !important;
  }

  /* Separate title and content containers in mobile view */
  .bucket-container {
    display: flex !important;
    flex-direction: column !important;
    height: calc(100vh - 130px) !important; /* Full height minus navbars and padding */
    padding: 0 !important; /* No padding - margins handle all spacing */
    box-sizing: border-box !important;
  }

  .bucket-container .bucket-title-header {
    /* Fixed title container - never scrolls */
    position: static !important;
    flex-shrink: 0 !important;
    height: 50px !important; /* Fixed height */
    background: linear-gradient(135deg, rgb(30, 30, 30) 0%, rgb(40, 40, 40) 100%) !important;
    padding: 0 8px !important; /* Internal padding for text */
    border-radius: 6px !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    box-sizing: border-box !important; /* Ensure consistent box model */
    /* Maximum width - no outer margins for widest containers */
    left: 0 !important;
    right: 0 !important;
    width: 100% !important; /* Full width - no margins */
    margin-left: 0 !important;
    margin-right: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 2px !important; /* Only small gap below title */
  }

  .bucket-container .bucket-content {
    /* Scrollable content container - independent scrolling */
    flex: 1 1 !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    padding: 7px !important; /* Keep 7px internal padding for tickets */
    background: rgba(255, 255, 255, 0.02) !important;
    border-radius: 6px !important;
    border: 1px solid rgba(255, 255, 255, 0.05) !important;
    box-sizing: border-box !important; /* Ensure consistent box model */
    /* Maximum width to match title container */
    left: 0 !important;
    right: 0 !important;
    width: 100% !important; /* Full width - no margins */
    margin-left: 0 !important;
    margin-right: 0 !important;
    margin-top: 0 !important; /* No top margin (gap from title container) */
    margin-bottom: 0 !important;
    /* Custom scrollbar */
    scrollbar-width: thin !important;
    scrollbar-color: rgba(255, 255, 255, 0.3) transparent !important;
  }

  .bucket-container .bucket-content::-webkit-scrollbar {
    width: 6px !important;
  }

  .bucket-container .bucket-content::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.2) !important;
    border-radius: 3px !important;
  }

  .bucket-container .bucket-content::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3) !important;
    border-radius: 3px !important;
  }

  .bucket-container .bucket-content::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5) !important;
  }

  /* Ensure bucket elements don't overlap */
  .bucket-container {
    position: relative !important;
    z-index: 1 !important;
  }

  .bucket-container + .bucket-container {
    margin-left: 0 !important;
  }

  /* Enhanced mobile scrolling experience */
  .bucket-container-scroll {
    /* Momentum scrolling for iOS */
    -webkit-overflow-scrolling: touch !important;
    /* Prevent scroll chaining */
    overscroll-behavior-x: contain !important;
    /* Smooth scrolling */
    scroll-padding: 0 calc(50vw - 150px) !important;
  }

  /* Hide scrollbar on mobile */
  .bucket-container-scroll::-webkit-scrollbar {
    display: none !important;
  }

  /* Ensure body doesn't scroll horizontally on mobile */
  body {
    overflow-x: hidden !important;
    width: 100vw !important;
    max-width: 100vw !important;
  }

  /* Prevent viewport issues */
  html {
    overflow-x: hidden !important;
    width: 100vw !important;
    max-width: 100vw !important;
  }

  /* Fix container widths */
  .App {
    width: 100vw !important;
    max-width: 100vw !important;
    overflow-x: hidden !important;
  }

  /* Better touch handling */
  .bucket-container {
    touch-action: pan-x !important;
  }

  /* Fix any potential z-index issues */
  .bucket-container > div {
    z-index: 1 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA,iCAAiC,qBAAqB,EAAE;AACxD,iCAAiC,qBAAqB,EAAE;AACxD,iCAAiC,qBAAqB,EAAE;AACxD,iCAAiC,qBAAqB,EAAE;AACxD,iCAAiC,qBAAqB,EAAE;;AAExD,sBAAsB;AACtB;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;;;EAGE;;AAEF,wDAAwD;AACxD;EACE,kBAAkB,EAAE,0DAA0D;EAC9E,kEAAkE;EAClE,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;EACzB,4BAA4B,EAAE,iDAAiD;EAC/E,0CAA0C;EAC1C,yBAAyB;EACzB,4DAA4D;EAC5D,qBAAqB;AACvB;;AAEA,8EAA8E;AAC9E;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oDAAoD;EACpD,qGAAqG;EACrG,yEAAyE;EACzE,UAAU;EACV,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,+DAA+D;AACjE;;AAEA,0CAA0C;AAC1C;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,qCAAqC;AACrC;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,sDAAsD;EACtD;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,2BAA2B;IAC3B,6BAA6B;IAC7B,wCAAwC;IACxC,4CAA4C;IAC5C,0BAA0B;IAC1B,oBAAoB;IACpB,0CAA0C;IAC1C,kCAAkC;IAClC,6BAA6B;IAC7B,kCAAkC;IAClC,gCAAgC;IAChC,mCAAmC;EACrC;;EAEA,0BAA0B;EAC1B;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,oCAAoC;IACpC,yBAAyB;IACzB,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA,sDAAsD;EACtD;IACE,0CAA0C;EAC5C;;EAEA,sDAAsD;EACtD;IACE,2CAA2C;EAC7C;;EAEA,0BAA0B;EAC1B;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,0CAA0C;IAC1C,iCAAiC;IACjC,wBAAwB;IACxB,oBAAoB;IACpB,6BAA6B;IAC7B,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA,6CAA6C;EAC7C;IACE,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA,yBAAyB;EACzB;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,mDAAmD;IACnD,sCAAsC;IACtC,4DAA4D;IAC5D,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,oDAAoD;EACtD;;EAEA,iCAAiC;EACjC;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;IAC1B,6BAA6B;IAC7B,sDAAsD;IACtD,sDAAsD;IACtD,qCAAqC;EACvC;;EAEA;;IAEE,qDAAqD;IACrD,iDAAiD;IACjD,iCAAiC;EACnC;;EAEA;IACE,mDAAmD;IACnD,iDAAiD;IACjD,sDAAsD;IACtD,gCAAgC;EAClC;;EAEA,0CAA0C;EAC1C;IACE,4BAA4B;EAC9B;;EAEA,sCAAsC;EACtC;IACE,wBAAwB;EAC1B;;EAEA;IACE,mCAAmC;IACnC,gCAAgC;EAClC;;EAEA,0BAA0B;EAC1B;IACE,6BAA6B,EAAE,2CAA2C;EAC5E;;EAEA,yBAAyB;EACzB;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,+BAA+B;EACjC;;EAEA,oCAAoC;EACpC;IACE,4BAA4B;IAC5B,0CAA0C;IAC1C,4BAA4B;EAC9B;;EAEA,yDAAyD;EACzD;IACE,wBAAwB;IACxB,iCAAiC;IACjC,sCAAsC,EAAE,0CAA0C;IAClF,qBAAqB,EAAE,4CAA4C;IACnE,iCAAiC;EACnC;;EAEA;IACE,0CAA0C;IAC1C,2BAA2B;IAC3B,yBAAyB;IACzB,uBAAuB,EAAE,iBAAiB;IAC1C,wFAAwF;IACxF,yBAAyB,EAAE,8BAA8B;IACzD,6BAA6B;IAC7B,qDAAqD;IACrD,oDAAoD;IACpD,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,iCAAiC,EAAE,gCAAgC;IACnE,2DAA2D;IAC3D,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB,EAAE,4BAA4B;IACpD,yBAAyB;IACzB,0BAA0B;IAC1B,wBAAwB;IACxB,6BAA6B,EAAE,+BAA+B;EAChE;;EAEA;IACE,yDAAyD;IACzD,oBAAkB;IAClB,2BAA2B;IAC3B,6BAA6B;IAC7B,uBAAuB,EAAE,0CAA0C;IACnE,gDAAgD;IAChD,6BAA6B;IAC7B,sDAAsD;IACtD,iCAAiC,EAAE,gCAAgC;IACnE,2CAA2C;IAC3C,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB,EAAE,4BAA4B;IACpD,yBAAyB;IACzB,0BAA0B;IAC1B,wBAAwB,EAAE,6CAA6C;IACvE,2BAA2B;IAC3B,qBAAqB;IACrB,gCAAgC;IAChC,gEAAgE;EAClE;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,yCAAyC;IACzC,6BAA6B;EAC/B;;EAEA;IACE,+CAA+C;IAC/C,6BAA6B;EAC/B;;EAEA;IACE,+CAA+C;EACjD;;EAEA,yCAAyC;EACzC;IACE,6BAA6B;IAC7B,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,yCAAyC;EACzC;IACE,+BAA+B;IAC/B,4CAA4C;IAC5C,4BAA4B;IAC5B,yCAAyC;IACzC,qBAAqB;IACrB,+CAA+C;EACjD;;EAEA,6BAA6B;EAC7B;IACE,wBAAwB;EAC1B;;EAEA,sDAAsD;EACtD;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA,4BAA4B;EAC5B;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA,yBAAyB;EACzB;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA,0BAA0B;EAC1B;IACE,8BAA8B;EAChC;;EAEA,qCAAqC;EACrC;IACE,qBAAqB;EACvB;AACF","sourcesContent":["/* Global body styles to prevent white flash */\r\nbody {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background-color: #252525;\r\n  min-height: 100vh;\r\n}\r\n\r\n#root {\r\n  min-height: 100vh;\r\n}\r\n\r\n.App {\r\n  text-align: center;\r\n  min-height: 100vh;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/* Authentication Styles */\r\n.login-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 100vh;\r\n  background: #181a1b;\r\n  background-size: cover;\r\n}\r\n\r\n.login-card {\r\n  background-color: rgba(24, 26, 27, 0.9);\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.7);\r\n  padding: 2rem;\r\n  width: 100%;\r\n  max-width: 400px;\r\n  color: white;\r\n}\r\n\r\n.login-card h2 {\r\n  margin-bottom: 1.5rem;\r\n  text-align: center;\r\n  font-size: 2rem;\r\n  color: #ffffff;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.form-group label {\r\n  display: block;\r\n  margin-bottom: 0.5rem;\r\n  font-weight: bold;\r\n  text-align: left;\r\n}\r\n\r\n.form-group input {\r\n  width: 100%;\r\n  padding: 0.75rem;\r\n  border: 1px solid #444;\r\n  border-radius: 4px;\r\n  background-color: #222;\r\n  color: white;\r\n  font-size: 1rem;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.form-group input:focus {\r\n  outline: none;\r\n  border-color: #4a9eff;\r\n}\r\n\r\n.login-button {\r\n  width: 100%;\r\n  padding: 0.75rem;\r\n  background-color: #4a9eff;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.login-button:hover {\r\n  background-color: #3a8aff;\r\n}\r\n\r\n.error-message {\r\n  background-color: rgba(255, 0, 0, 0.1);\r\n  border-left: 4px solid #ff3333;\r\n  color: #ff3333;\r\n  padding: 0.75rem;\r\n  margin-bottom: 1.5rem;\r\n  border-radius: 4px;\r\n}\r\n\r\n.loading-spinner {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100vh;\r\n  color: white;\r\n  background-color: #181a1b;\r\n}\r\n\r\n.spinner {\r\n  border: 4px solid rgba(255, 255, 255, 0.1);\r\n  border-radius: 50%;\r\n  border-top: 4px solid #4a9eff;\r\n  width: 40px;\r\n  height: 40px;\r\n  animation: spin 1s linear infinite;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n/* Navbar Styles */\r\n.navbar {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background-color: #222;\r\n  padding: 0.75rem 1.5rem;\r\n  color: white;\r\n  border-bottom: 1px solid #444;\r\n}\r\n\r\n.navbar-brand {\r\n  font-size: 1.5rem;\r\n  font-weight: bold;\r\n  color: #4a9eff;\r\n}\r\n\r\n.navbar-user {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.username {\r\n  font-weight: bold;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.admin-badge {\r\n  background-color: #4a9eff;\r\n  color: white;\r\n  font-size: 0.7rem;\r\n  padding: 0.2rem 0.4rem;\r\n  border-radius: 4px;\r\n  font-weight: bold;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.logout-button {\r\n  background-color: transparent;\r\n  border: 1px solid #666;\r\n  color: white;\r\n  padding: 0.4rem 0.75rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.logout-button:hover {\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n  border-color: #999;\r\n}\r\n\r\n/* Smooth Loading Animations */\r\n@keyframes fadeInUp {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(30px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes fadeOutDown {\r\n  0% {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: translateY(30px);\r\n  }\r\n}\r\n\r\n@keyframes fadeOutUp {\r\n  0% {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: translateY(-30px);\r\n  }\r\n}\r\n\r\n@keyframes slideInFromLeft {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateX(-30px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n@keyframes slideOutToRight {\r\n  0% {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: translateX(50px);\r\n  }\r\n}\r\n\r\n/* Bucket fade-in animation with staggered delay */\r\n.bucket-container {\r\n  position: relative;\r\n  transition: transform 0.5s ease, opacity 0.3s ease;\r\n}\r\n\r\n.bucket-container--fade-in {\r\n  animation: slideInFromLeft 0.6s ease-out;\r\n  animation-fill-mode: both;\r\n}\r\n\r\n.bucket-container--animating-out {\r\n  animation: slideOutToRight 0.4s ease-out;\r\n  animation-fill-mode: both;\r\n}\r\n\r\n.bucket-container:nth-child(1) { animation-delay: 0.1s; }\r\n.bucket-container:nth-child(2) { animation-delay: 0.2s; }\r\n.bucket-container:nth-child(3) { animation-delay: 0.3s; }\r\n.bucket-container:nth-child(4) { animation-delay: 0.4s; }\r\n.bucket-container:nth-child(5) { animation-delay: 0.5s; }\r\n\r\n/* Ticket animations */\r\n.ticket-item {\r\n  animation: fadeInUp 0.4s ease-out;\r\n  animation-fill-mode: both;\r\n}\r\n\r\n.ticket-item-exit {\r\n  animation: fadeOutDown 0.3s ease-out;\r\n  animation-fill-mode: both;\r\n}\r\n\r\n.ticket-item-done {\r\n  animation: fadeOutUp 0.2s ease-out;\r\n  animation-fill-mode: both;\r\n}\r\n\r\n/*\r\n * NOTE: Removed global * { transition } rule - it was breaking CSS animations\r\n * Transitions should be applied to specific elements that need them instead\r\n */\r\n\r\n/* Bucket container with infinite scrolling background */\r\n.bucket-container-scroll {\r\n  position: relative; /* Required for absolute positioning of ::before overlay */\r\n  /* Background scrolls with container content - attachment: local */\r\n  background-color: #252525;\r\n  background-size: 760px 760px;\r\n  background-repeat: repeat;\r\n  background-attachment: local; /* Scrolls WITH the container in all directions */\r\n  /* Smooth transitions for layout changes */\r\n  transition: all 0.3s ease;\r\n  /* CSS variable for brightness control via opacity overlay */\r\n  --bg-brightness: 100%;\r\n}\r\n\r\n/* Dark overlay for brightness control - only affects background, not navbar */\r\n.bucket-container-scroll::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  /* Dark overlay - opacity controlled by brightness */\r\n  /* brightness 100% = no overlay, brightness 50% = 50% dark overlay, brightness 200% = white overlay */\r\n  background-color: rgba(0, 0, 0, calc((100 - var(--bg-brightness)) / 100));\r\n  z-index: 0;\r\n  pointer-events: none;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.bucket-container-scroll > * {\r\n  position: relative;\r\n  z-index: 1;\r\n  transition: transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);\r\n}\r\n\r\n/* Custom scrollbar for bucket container */\r\n.bucket-container-scroll::-webkit-scrollbar {\r\n  width: 6px;\r\n  height: 6px;\r\n}\r\n\r\n.bucket-container-scroll::-webkit-scrollbar-track {\r\n  background: rgba(0, 0, 0, 0.2);\r\n  border-radius: 3px;\r\n}\r\n\r\n.bucket-container-scroll::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.3);\r\n  border-radius: 3px;\r\n}\r\n\r\n.bucket-container-scroll::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n/* Hide scrollbar for bucket navbar */\r\n.bucket-navbar::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.bucket-navbar {\r\n  -ms-overflow-style: none;\r\n  scrollbar-width: none;\r\n}\r\n\r\n/* Mobile Media Queries */\r\n@media (max-width: 768px) {\r\n  /* Mobile bucket container with horizontal scrolling */\r\n  .bucket-container-scroll {\r\n    display: flex !important;\r\n    flex-direction: row !important;\r\n    overflow-x: auto !important;\r\n    overflow-y: hidden !important;\r\n    scroll-snap-type: x proximity !important;\r\n    -webkit-overflow-scrolling: touch !important;\r\n    padding: 10px 0 !important;\r\n    gap: 20px !important;\r\n    min-height: calc(100vh - 120px) !important;\r\n    align-items: flex-start !important;\r\n    /* Enhanced scroll behavior */\r\n    scroll-behavior: smooth !important;\r\n    scrollbar-width: none !important;\r\n    -ms-overflow-style: none !important;\r\n  }\r\n\r\n  /* Mobile bucket styling */\r\n  .bucket-container {\r\n    min-width: 320px !important;\r\n    width: 320px !important;\r\n    scroll-snap-align: center !important;\r\n    flex-shrink: 0 !important;\r\n    flex-grow: 1 !important;\r\n    margin-right: 0 !important;\r\n    display: block !important;\r\n  }\r\n\r\n  /* First bucket gets left padding to center properly */\r\n  .bucket-container:first-child {\r\n    margin-left: calc(50vw - 160px) !important;\r\n  }\r\n\r\n  /* Last bucket gets right padding to center properly */\r\n  .bucket-container:last-child {\r\n    margin-right: calc(50vw - 160px) !important;\r\n  }\r\n\r\n  /* Mobile bucket content */\r\n  .bucket-container > div {\r\n    width: 320px !important;\r\n    min-width: 320px !important;\r\n    height: auto !important;\r\n    max-height: calc(100vh - 140px) !important;\r\n    box-sizing: border-box !important;\r\n    padding: 12px !important;\r\n    margin: 0 !important;\r\n    position: relative !important;\r\n    overflow-y: auto !important;\r\n    overflow-x: hidden !important;\r\n  }\r\n\r\n  /* Ensure bucket content has proper spacing */\r\n  .bucket-container > div > div {\r\n    width: 100% !important;\r\n    box-sizing: border-box !important;\r\n  }\r\n\r\n  /* Mobile bucket navbar */\r\n  .bucket-navbar {\r\n    position: fixed !important;\r\n    top: 60px !important;\r\n    bottom: auto !important;\r\n    left: 0 !important;\r\n    right: 0 !important;\r\n    height: 50px !important;\r\n    background-color: rgba(24, 26, 27, 0.98) !important;\r\n    backdrop-filter: blur(15px) !important;\r\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2) !important;\r\n    border-top: none !important;\r\n    padding: 8px 15px !important;\r\n    z-index: 90 !important;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3) !important;\r\n  }\r\n\r\n  /* Mobile bucket navbar buttons */\r\n  .bucket-nav-button {\r\n    min-width: 80px !important;\r\n    height: 44px !important;\r\n    padding: 8px 12px !important;\r\n    font-size: 12px !important;\r\n    border-radius: 8px !important;\r\n    background-color: rgba(255, 255, 255, 0.12) !important;\r\n    border: 1px solid rgba(255, 255, 255, 0.25) !important;\r\n    touch-action: manipulation !important;\r\n  }\r\n\r\n  .bucket-nav-button:hover,\r\n  .bucket-nav-button:active {\r\n    background-color: rgba(255, 255, 255, 0.2) !important;\r\n    border-color: rgba(255, 255, 255, 0.4) !important;\r\n    transform: scale(1.05) !important;\r\n  }\r\n\r\n  .bucket-nav-button--highlight {\r\n    background-color: rgba(0, 123, 255, 0.8) !important;\r\n    border: 2px solid rgba(0, 123, 255, 1) !important;\r\n    box-shadow: 0 0 15px rgba(0, 123, 255, 0.6) !important;\r\n    transform: scale(1.1) !important;\r\n  }\r\n\r\n  /* Adjust main content for mobile navbar */\r\n  .App {\r\n    padding-bottom: 0 !important;\r\n  }\r\n\r\n  /* Mobile-specific scrollbar styling */\r\n  .bucket-container-scroll::-webkit-scrollbar {\r\n    display: none !important;\r\n  }\r\n\r\n  .bucket-container-scroll {\r\n    -ms-overflow-style: none !important;\r\n    scrollbar-width: none !important;\r\n  }\r\n\r\n  /* Mobile ticket styling */\r\n  .ticket-item {\r\n    margin-bottom: 7px !important; /* 7px margins matching all other spacing */\r\n  }\r\n\r\n  /* Mobile navbar at top */\r\n  .navbar {\r\n    position: fixed !important;\r\n    top: 0 !important;\r\n    left: 0 !important;\r\n    right: 0 !important;\r\n    z-index: 101 !important;\r\n    height: 60px !important;\r\n    padding: 0.5rem 1rem !important;\r\n  }\r\n\r\n  /* Adjust content for fixed navbar */\r\n  .bucket-container-scroll {\r\n    margin-top: 110px !important;\r\n    min-height: calc(100vh - 110px) !important;\r\n    padding-top: 10px !important;\r\n  }\r\n\r\n  /* Separate title and content containers in mobile view */\r\n  .bucket-container {\r\n    display: flex !important;\r\n    flex-direction: column !important;\r\n    height: calc(100vh - 130px) !important; /* Full height minus navbars and padding */\r\n    padding: 0 !important; /* No padding - margins handle all spacing */\r\n    box-sizing: border-box !important;\r\n  }\r\n\r\n  .bucket-container .bucket-title-header {\r\n    /* Fixed title container - never scrolls */\r\n    position: static !important;\r\n    flex-shrink: 0 !important;\r\n    height: 50px !important; /* Fixed height */\r\n    background: linear-gradient(135deg, rgb(30, 30, 30) 0%, rgb(40, 40, 40) 100%) !important;\r\n    padding: 0 8px !important; /* Internal padding for text */\r\n    border-radius: 6px !important;\r\n    border: 1px solid rgba(255, 255, 255, 0.1) !important;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3) !important;\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n    box-sizing: border-box !important; /* Ensure consistent box model */\r\n    /* Maximum width - no outer margins for widest containers */\r\n    left: 0 !important;\r\n    right: 0 !important;\r\n    width: 100% !important; /* Full width - no margins */\r\n    margin-left: 0 !important;\r\n    margin-right: 0 !important;\r\n    margin-top: 0 !important;\r\n    margin-bottom: 2px !important; /* Only small gap below title */\r\n  }\r\n\r\n  .bucket-container .bucket-content {\r\n    /* Scrollable content container - independent scrolling */\r\n    flex: 1 !important;\r\n    overflow-y: auto !important;\r\n    overflow-x: hidden !important;\r\n    padding: 7px !important; /* Keep 7px internal padding for tickets */\r\n    background: rgba(255, 255, 255, 0.02) !important;\r\n    border-radius: 6px !important;\r\n    border: 1px solid rgba(255, 255, 255, 0.05) !important;\r\n    box-sizing: border-box !important; /* Ensure consistent box model */\r\n    /* Maximum width to match title container */\r\n    left: 0 !important;\r\n    right: 0 !important;\r\n    width: 100% !important; /* Full width - no margins */\r\n    margin-left: 0 !important;\r\n    margin-right: 0 !important;\r\n    margin-top: 0 !important; /* No top margin (gap from title container) */\r\n    margin-bottom: 0 !important;\r\n    /* Custom scrollbar */\r\n    scrollbar-width: thin !important;\r\n    scrollbar-color: rgba(255, 255, 255, 0.3) transparent !important;\r\n  }\r\n\r\n  .bucket-container .bucket-content::-webkit-scrollbar {\r\n    width: 6px !important;\r\n  }\r\n\r\n  .bucket-container .bucket-content::-webkit-scrollbar-track {\r\n    background: rgba(0, 0, 0, 0.2) !important;\r\n    border-radius: 3px !important;\r\n  }\r\n\r\n  .bucket-container .bucket-content::-webkit-scrollbar-thumb {\r\n    background: rgba(255, 255, 255, 0.3) !important;\r\n    border-radius: 3px !important;\r\n  }\r\n\r\n  .bucket-container .bucket-content::-webkit-scrollbar-thumb:hover {\r\n    background: rgba(255, 255, 255, 0.5) !important;\r\n  }\r\n\r\n  /* Ensure bucket elements don't overlap */\r\n  .bucket-container {\r\n    position: relative !important;\r\n    z-index: 1 !important;\r\n  }\r\n\r\n  .bucket-container + .bucket-container {\r\n    margin-left: 0 !important;\r\n  }\r\n\r\n  /* Enhanced mobile scrolling experience */\r\n  .bucket-container-scroll {\r\n    /* Momentum scrolling for iOS */\r\n    -webkit-overflow-scrolling: touch !important;\r\n    /* Prevent scroll chaining */\r\n    overscroll-behavior-x: contain !important;\r\n    /* Smooth scrolling */\r\n    scroll-padding: 0 calc(50vw - 150px) !important;\r\n  }\r\n\r\n  /* Hide scrollbar on mobile */\r\n  .bucket-container-scroll::-webkit-scrollbar {\r\n    display: none !important;\r\n  }\r\n\r\n  /* Ensure body doesn't scroll horizontally on mobile */\r\n  body {\r\n    overflow-x: hidden !important;\r\n    width: 100vw !important;\r\n    max-width: 100vw !important;\r\n  }\r\n\r\n  /* Prevent viewport issues */\r\n  html {\r\n    overflow-x: hidden !important;\r\n    width: 100vw !important;\r\n    max-width: 100vw !important;\r\n  }\r\n\r\n  /* Fix container widths */\r\n  .App {\r\n    width: 100vw !important;\r\n    max-width: 100vw !important;\r\n    overflow-x: hidden !important;\r\n  }\r\n\r\n  /* Better touch handling */\r\n  .bucket-container {\r\n    touch-action: pan-x !important;\r\n  }\r\n\r\n  /* Fix any potential z-index issues */\r\n  .bucket-container > div {\r\n    z-index: 1 !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
